import { NgIf } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';
import {
  MedallionBannerComponent as MachMedallionBannerComponent,
  Notification,
  NotificationComponent
} from '@com-delta-idp/mnx-skymiles-shared';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import {
  Link,
  MedallionBannerComponent,
  SkeletonLoaderDirective
} from '@com-delta-omnichannel/aura';
import { MenuComponent } from '../../features';
import { setAdobeAnalytics } from '../../utils/adobe-analytics.utils';
import * as ANALYTICS from './models/analytics.constant';
import { LandingPage } from './models/landing-page.interfaces';

@Component({
  imports: [
    MenuComponent,
    SkeletonLoaderDirective,
    MedallionBannerComponent,
    NotificationComponent,
    MachMedallionBannerComponent,
    NgIf
  ],
  selector: 'idp-landing-page-ui',
  standalone: true,
  styleUrls: ['./landing-page.component.scss'],
  templateUrl: './landing-page.component.html'
})
export class LandingPageComponent implements AfterViewInit {
  @Input() content: LandingPage = {} as LandingPage;
  @Input() notification: Notification | null = null;
  @Input() accessToken = '';
  // TODO::: MGM (Suganiya, Kamalam): Flag value will be sed from config
  showAuraMedallionBanner = true;

  constructor(private analytics: AnalyticsService) {}

  ngAfterViewInit(): void {
    this.triggerAnalyticsEvent();
  }

  triggerAnalyticsEvent() {
    const analytic = this.content.medallionBanner.analyticsEvent;
    if (analytic && analytic.name && analytic.value) {
      this.analytics.dispatchCustomEvent<string>(analytic.name, analytic.value);
    }
  }

  redirect(link: string, type = '_self') {
    window.open(link, type);
  }

  onClickAnalytics(event: Link) {
    setAdobeAnalytics({
      event: ANALYTICS.EVENT_TYPE.CLICK,
      event_detail: ANALYTICS.EVENT_TYPE.CLICK,
      user: {
        attributes: {
          is_logged_in: ANALYTICS.LOGIN_STATUS.AUTHENTICATED
        }
      },
      click: {
        name: event.label,
        type: ANALYTICS.CLICK_DETAIL.LINK,
        page_section: ANALYTICS.CLICK_DETAIL.MEDALLION_BANNER_BENEFITS,
        page_subsection: '',
        action: event.url
      }
    });
  }
}
